/* import __COLOCATED_TEMPLATE__ from './need-help-card.hbs'; */
/* RESPONSIBLE TEAM: team-growth-opportunities */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

export default class NeedHelpCard extends Component {
  @service declare purchaseAnalyticsService: any;

  @action
  trackClickEvent() {
    this.purchaseAnalyticsService.trackEvent({
      action: 'clicked',
      context: 'update_subscription_need_help_card',
      place: 'update_subscription',
      object: 'get-advice',
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Billing::UpdateEarlyStageSubscription::NeedHelpCard': typeof NeedHelpCard;
    'billing/update-early-stage-subscription/need-help-card': typeof NeedHelpCard;
  }
}
